import React from "react";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../siteConfig";

export default function WebsiteSeoCheckerPage() {
  return (
    <div className="app page-grid">
      <Helmet>
        <title>Website Discoverability Checker | OptiSiteSEO</title>
        <meta
          name="description"
          content="Use the OptiSiteSEO checker to find technical SEO and visibility risks on your website and get prioritized implementation notes."
        />
        <link rel="canonical" href={canonicalUrl("/website-seo-checker")} />
      </Helmet>

      <section className="card section">
        <p className="eyebrow">Website discoverability checker</p>
        <h1>Check technical SEO issues in under a minute</h1>
        <ul className="bullets">
          <li>Prioritized findings for technical SEO, discoverability, and UX</li>
          <li>Actionable fixes with business impact</li>
          <li>Useful for operators, founders, and development teams that need implementation priorities</li>
        </ul>
        <div className="cta-row">
          <a className="primary" href="/app/index.html">
            Run Free SEO Scan
          </a>
          <a className="secondary" href="/demo/index.html">
            View a sample
          </a>
        </div>
      </section>
    </div>
  );
}
